import { useLocation, useNavigate } from 'react-router-dom';
import { sentryLog } from '../Utils/SentryLog';
import { getLqzyParams } from '../Utils/GetLqzyParams';

function UserProfile({userDetails, forSheetsExtension}){

    const isShowConsole = process.env.NODE_ENV === 'development';

    const navigate = useNavigate();

    isShowConsole && console.log('user details incoming prop: ', userDetails);

    const openPricingPage = e => {
        try{
            const query = getLqzyParams();
            navigate(`/${forSheetsExtension ? 'sheets-extension-pricing' : 'pricing'}${query}`);
        }catch(err){
            isShowConsole && console.error('error in openPricingPage method: ', err);
            sentryLog(`UserProfile.js - openPricingPage failed: ${err?.message || err} | user: ${JSON.stringify(userDetails)}`);
        }
    }

    const userCreditBalance = forSheetsExtension ? (userDetails?.topUpBalance + userDetails?.defaultBalance) : 5;

    return(
        <div className='userProfile'>
            <div className='pageTitle'>Profile Details</div>
            <div className='pageContent'>
                <div className='detail'>
                    <div className='prop'>Name:</div>
                    <div className='val'>{userDetails.name}</div>
                </div>
                <div className='detail'>
                    <div className='prop'>Email:</div>
                    <div className='val'>{userDetails.email}</div>
                </div>
                {forSheetsExtension ? <div className='detail'>
                    <div className='prop'>Current Balance:</div>
                    <div className='val'>
                        {userDetails.isExtPremium ? 
                                <div className='planVal'>{userCreditBalance} credits</div>
                             : 
                            <>
                                <div className='planVal'>{userCreditBalance} credits</div>
                                <div className='upgradeCta' onClick={openPricingPage}>Upgrade for more</div>
                            </>                            
                        }
                    </div>
                </div> : <div className='detail'>
                    <div className='prop'>Current Plan:</div>
                    <div className='val'>
                        {userDetails.isPremium ? 
                                <div className='planVal'>{userDetails.planType}</div>
                             : 
                            <>
                                <div className='planVal'>Free User</div>
                                <div className='upgradeCta' onClick={openPricingPage}>Upgrade to Premium</div>
                            </>                            
                        }
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default UserProfile;